import React, { FC } from 'react'

export const ArrowLeft: FC = () => (
  <svg height='1em' viewBox='0 0 44 44'>
    <g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
      <g transform='translate(-100.000000, -22.000000)'>
        <g transform='translate(100.000000, 22.000000)'>
          <rect x='0' y='0' width='44' height='44' />
          <g
            transform='translate(12.000000, 4.000000)'
            fill='currentColor'
            fillRule='nonzero'
          >
            <path d='M19.4833058,2.71985611 L3.53051139,17.0699744 C3.0173831,17.5315665 2.97522952,18.3220903 3.43630803,18.8357433 L3.43630796,18.8357432 C3.46601289,18.8688164 3.49745845,18.9002801 3.53051133,18.9300007 L19.4833057,33.2801611 C20.1234001,33.8559077 20.1759552,34.8420707 19.6007967,35.4827774 C19.0256382,36.1235263 18.0404824,36.1761351 17.400388,35.6003885 L1.44759367,21.2502703 L1.4475933,21.25027 C1.33208743,21.1463692 1.22220259,21.036372 1.11840792,20.920748 C-0.49302969,19.1256817 -0.345639536,16.3628317 1.4475933,14.7497465 L17.4003877,0.399628282 C18.0404821,-0.176160428 19.0256378,-0.123509422 19.6007963,0.517239417 C20.1759548,1.1579461 20.1233997,2.14410915 19.4833053,2.7198557 L19.4833058,2.71985611 Z' />
          </g>
        </g>
      </g>
    </g>
  </svg>
)
